import { render } from "./ErrorHandler.vue?vue&type=template&id=827cf3e0"
import script from "./ErrorHandler.vue?vue&type=script&lang=js"
export * from "./ErrorHandler.vue?vue&type=script&lang=js"
script.render = render

export default script